import { useTheme } from '@mui/material';
import { useMemo } from 'react';
import useDesignTokens from '../../../themes/useDesignTokens';

const useAssetronOverlayDialogStyles = (
  isLogoVisible: boolean,
  hasContentPadding: boolean,
  fitContentHeight: boolean,
) => {
  const theme = useTheme();
  const tokens = useDesignTokens();

  const styles = useMemo(
    () => ({
      paperProps: {
        width: '640px',
        height: fitContentHeight ? 'auto' : '704px',
        maxWidth: '640px',
        borderRadius: tokens.radius.xs,
      },
      backButtonStyle: {
        position: 'absolute',
        left: theme.sizeGuide.md,
        top: theme.sizeGuide.md,
        color: tokens.colors.text.primary,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      },
      backButtonBoxStyle: {
        position: 'absolute',
        left: theme.sizeGuide.md,
        top: theme.sizeGuide.md,
        width: '36px',
        height: '36px',
        border: '1.67px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: tokens.colors.text.secondary,
        cursor: 'pointer',
        '&:hover': { backgroundColor: tokens.colors.bg.primaryHover },
      },
      closeButtonBoxStyle: {
        position: 'absolute',
        right: 8,
        top: 8,
        width: '36px',
        height: '36px',
        border: '1.67px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: tokens.colors.text.primary,
        cursor: 'pointer',
        '&:hover': { backgroundColor: tokens.colors.bg.primaryHover },
      },
      closeButtonStyle: {
        width: theme.sizeGuide['2xl'],
        height: theme.sizeGuide['2xl'],
      },
      logoDialogStyle: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'top',
        paddingTop: isLogoVisible ? theme.sizeGuide.xl : 0,
        marginBottom: theme.sizeGuide.xl,
      },
      DialogContentStyle: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: hasContentPadding ? theme.sizeGuide.xl : 0,
      },
    }),
    [theme, tokens, isLogoVisible, hasContentPadding, fitContentHeight],
  );
  return styles;
};

export default useAssetronOverlayDialogStyles;
